/* eslint-disable @typescript-eslint/no-explicit-any */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * Each react-table `row` has a `state` property and a `setState` method for
 * setting it. This function returns corresponding members that get and set the
 * `publicRowState` key from `row.state`.
 */
export const getPublicRowStateProps = (row) => ({
    rowState: row.state.publicRowState,
    setRowState: (updater) => {
        row.setState((_a) => {
            var { publicRowState: current } = _a, rest = __rest(_a, ["publicRowState"]);
            return (Object.assign(Object.assign({}, rest), { publicRowState: typeof updater === 'function' ? updater(current) : updater }));
        });
    },
});
//# sourceMappingURL=getPublicRowStateProps.js.map